{
    "RecordingList_Column_Description": "Description",
    "RecordingList_Column_Type": "Taper",
    "RecordingList_Column_TelSys": "Serveur de téléphonie",
    "RecordingList_Column_Partition": "Partition",
    "RecordingList_Scope_All": "Tous",
    "RecordingList_Scope_ServiceWide": "Service à l'échelle de l'ensemble du service",
    "RecordingList_Scope_SystemWide": "Système global",
    "RecordingList_Scope_Detached": "Détaché",
    "RecordingList_Type_All": "Tous",
    "RecordingList_Type_Dubber": "Dubber",
    "RecordingList_Scope_Label": "Portée",
    "RecordingList_Type_Label": "Taper",
    "NAME": "Liste des enregistrementsLangue"
}